import Loadable from 'mk2/helpers/Loadable';
import { Overlay } from 'react-overlays';

const OverlayLoadable = Loadable({
    loader: () => import('react-overlays' /* webpackChunkName: "react-overlays" */).then((module) => {
        return module.Overlay;
    }),
    modules: ['react-overlays'],
    webpack: () => [ require.resolveWeak('react-overlays') ],
});

export default OverlayLoadable;
